module.exports = __webpack_public_path__ + "img/full6-min.67c0e221.png";